import { useEffect, useState } from 'react';
import api from '../../utils/api';
import { format } from 'date-fns';

export default function AuditLogPage() {
  const [entries, setEntries] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const [loading, setLoading] = useState(true);
  const limit = 100;

  const load = (off) => {
    setLoading(true);
    api.get(`/api/audit?limit=${limit}&offset=${off}`)
      .then(r => { setEntries(r.data.entries); setTotal(r.data.total); setOffset(off); setLoading(false); })
      .catch(() => setLoading(false));
  };
  useEffect(() => { load(0); }, []);

  return (
    <>
      <div className="topbar"><h2>Audit Log</h2></div>
      <div className="page">
        <div className="card" style={{ padding: 0 }}>
          {loading ? <div className="loading">Loading…</div> : (
            <div className="table-wrap">
              <table style={{ fontSize: 13 }}>
                <thead><tr><th>When</th><th>User</th><th>Action</th><th>Detail</th><th>IP</th></tr></thead>
                <tbody>
                  {entries.map(e => (
                    <tr key={e.id}>
                      <td style={{ whiteSpace: 'nowrap' }}>{e.created_at ? format(new Date(e.created_at + 'Z'), 'MMM d, HH:mm') : ''}</td>
                      <td>{e.user_email || '—'}</td>
                      <td style={{ fontFamily: 'monospace', fontSize: 12 }}>{e.action}</td>
                      <td>{e.detail || (e.entity_type ? `${e.entity_type}${e.entity_id ? ' #' + e.entity_id : ''}` : '')}</td>
                      <td className="text-muted">{e.ip_address || ''}</td>
                    </tr>
                  ))}
                  {!entries.length && <tr><td colSpan={5} className="text-muted" style={{ padding: 16 }}>No audit entries.</td></tr>}
                </tbody>
              </table>
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12 }}>
          <button className="btn btn-secondary btn-sm" disabled={offset === 0} onClick={() => load(Math.max(0, offset - limit))}>← Newer</button>
          <span className="text-sm text-muted">{offset + 1}–{Math.min(offset + limit, total)} of {total}</span>
          <button className="btn btn-secondary btn-sm" disabled={offset + limit >= total} onClick={() => load(offset + limit)}>Older →</button>
        </div>
      </div>
    </>
  );
}
